// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayContainer_overlay__GEEj-"};